import { Check, X } from 'phosphor-react';

interface PlanComparisonTableProps {
  onSubscribe: () => void;
}

export function PlanComparisonTable({ onSubscribe }: PlanComparisonTableProps) {
  return (
    <div className="overflow-x-auto max-w-4xl">
      <div className="rounded-xl border theme-border overflow-hidden bg-[color:var(--card-bg)]">
        <table className="w-full">
          <thead>
            <tr className="border-b theme-border">
              <th className="text-left py-3 px-4 theme-text font-semibold bg-[color:color-mix(in_oklab,var(--card-bg)_85%,transparent)]">
                Recursos
              </th>
              <th className="text-center py-3 px-4 theme-text font-semibold bg-[color:color-mix(in_oklab,var(--card-bg)_85%,transparent)]">
                Plano Gratuito
              </th>
              <th className="text-center py-3 px-4 theme-text font-semibold bg-[color:var(--nt-primary)]/15 border-l theme-border">
                <div className="flex flex-col items-center gap-1">
                  <span className="text-base">Paladino Pro</span>
                  <span className="text-sm font-normal theme-text-muted">R$ 89,90/mês</span>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-b theme-border hover:bg-[color:color-mix(in_oklab,var(--card-bg)_90%,transparent)] transition-colors">
              <td className="py-3 px-4 theme-text text-sm font-medium">Projetos</td>
              <td className="py-3 px-4 text-center border-l theme-border">
                <span className="text-sm theme-text-muted">Até 3</span>
              </td>
              <td className="py-3 px-4 text-center bg-[color:var(--nt-primary)]/8 border-l theme-border">
                <Check className="w-5 h-5 text-[color:var(--nt-primary)] mx-auto" weight="bold" />
              </td>
            </tr>
            <tr className="border-b theme-border hover:bg-[color:color-mix(in_oklab,var(--card-bg)_90%,transparent)] transition-colors">
              <td className="py-3 px-4 theme-text text-sm font-medium">Agentes</td>
              <td className="py-3 px-4 text-center border-l theme-border">
                <span className="text-sm theme-text-muted">5 agentes</span>
              </td>
              <td className="py-3 px-4 text-center bg-[color:var(--nt-primary)]/8 border-l theme-border">
                <Check className="w-5 h-5 text-[color:var(--nt-primary)] mx-auto" weight="bold" />
              </td>
            </tr>
            <tr className="border-b theme-border hover:bg-[color:color-mix(in_oklab,var(--card-bg)_90%,transparent)] transition-colors">
              <td className="py-3 px-4 theme-text text-sm font-medium">Suporte</td>
              <td className="py-3 px-4 text-center border-l theme-border">
                <span className="text-sm theme-text-muted">Por email</span>
              </td>
              <td className="py-3 px-4 text-center bg-[color:var(--nt-primary)]/8 border-l theme-border">
                <span className="text-sm theme-text font-medium">Prioritário</span>
              </td>
            </tr>
            <tr className="border-b theme-border hover:bg-[color:color-mix(in_oklab,var(--card-bg)_90%,transparent)] transition-colors">
              <td className="py-3 px-4 theme-text text-sm font-medium">Integrações</td>
              <td className="py-3 px-4 text-center border-l theme-border">
                <X className="w-5 h-5 text-gray-400 dark:text-gray-500 mx-auto" weight="bold" />
              </td>
              <td className="py-3 px-4 text-center bg-[color:var(--nt-primary)]/8 border-l theme-border">
                <Check className="w-5 h-5 text-[color:var(--nt-primary)] mx-auto" weight="bold" />
              </td>
            </tr>
            <tr className="border-b theme-border hover:bg-[color:color-mix(in_oklab,var(--card-bg)_90%,transparent)] transition-colors">
              <td className="py-3 px-4 theme-text text-sm font-medium">Análises e Relatórios</td>
              <td className="py-3 px-4 text-center border-l theme-border">
                <X className="w-5 h-5 text-gray-400 dark:text-gray-500 mx-auto" weight="bold" />
              </td>
              <td className="py-3 px-4 text-center bg-[color:var(--nt-primary)]/8 border-l theme-border">
                <Check className="w-5 h-5 text-[color:var(--nt-primary)] mx-auto" weight="bold" />
              </td>
            </tr>
            <tr className="bg-[color:color-mix(in_oklab,var(--card-bg)_88%,transparent)]">
              <td className="py-3 px-4 theme-text text-sm font-semibold">Preço</td>
              <td className="py-3 px-4 text-center border-l theme-border">
                <div className="flex flex-col items-center gap-0.5">
                  <span className="text-xl font-bold theme-text">R$ 0,00</span>
                  <span className="text-xs theme-text-muted">/mês</span>
                </div>
              </td>
              <td className="py-3 px-4 text-center bg-[color:var(--nt-primary)]/8 border-l theme-border">
                <div className="flex flex-col items-center gap-3">
                  <div className="flex flex-col items-center gap-0.5">
                    <span className="text-xl font-bold theme-text">R$ 89,90</span>
                    <span className="text-xs theme-text-muted">/mês</span>
                  </div>
                  <button
                    type="button"
                    onClick={onSubscribe}
                    className="h-10 px-6 rounded-lg text-sm font-semibold transition-all cursor-pointer bg-[color:var(--nt-primary)] text-white shadow-[inset_0_-0.125rem_0_0_var(--nt-primary-inset-bottom),inset_0_0.125rem_0_0_var(--nt-primary-inset-top)] hover:brightness-95 hover:shadow-[inset_0_-0.125rem_0_0_var(--nt-primary-inset-bottom-hover),inset_0_0.125rem_0_0_var(--nt-primary-inset-top-hover)]"
                  >
                    Assinar
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
